export const XML_KEY = {
  DEVICE_ALARM: 'Device_alarm',
  UN_INST_ALARM: 'UnInst_alarm',
};

export const S_TYPE_XML_VALUE = {
  [XML_KEY.DEVICE_ALARM]: 26,
  [XML_KEY.UN_INST_ALARM]: 27,
};

export const S_TYPE_PARAMS = {
  STAT_PERIOD: 30,
  RELATIVE_TO_EMPLOYEE: 42,
  RELATIVE_TO_GROUP: 43,
  INCREASED_CPU: 44,
  CONS_CPU: 45,
};

export const PERSONAL_DATA_KEYS = {
  CHECK_PERS_DATA: 'checkpersdata',
  CHECK_IN_FILES: 'checkinfiles',
  CHECK_IN_PRINT: 'checkinprint',
  CHECK_IN_MESSENGER_TEXTS: 'checkinmessengertexts',
  AUDIO_TO_TEXT: 'audiototext',
};

export const PERSONAL_DATA_DEFAULTS = Object.fromEntries(Object.values(PERSONAL_DATA_KEYS).map((key) => [key, false]));
